import { render, staticRenderFns } from "./CreateCpInfo.vue?vue&type=template&id=c5d0aed8&scoped=true"
import script from "./CreateCpInfo.vue?vue&type=script&lang=js"
export * from "./CreateCpInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateCpInfo.vue?vue&type=style&index=0&id=c5d0aed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d0aed8",
  null
  
)

export default component.exports